import Stack from '@mui/material/Stack';
import InfoIcon from '@mui/icons-material/Info';
import Typography from '@mui/material/Typography';
import { useSkinStyles } from '../../hooks/useSkinStyles';
import { BETSLIP_ERROR_MESSAGE_SKIN_STYLES } from '../../styles/components/betslipErrorMessage';

import { mergeSx } from '../../utils/styles';

type BetslipErrorMessageProps = {
  message: string;
};

const BetslipErrorMessage = ({ message }: BetslipErrorMessageProps) => {
  const styles = useSkinStyles(BETSLIP_ERROR_MESSAGE_SKIN_STYLES);

  return (
    <Stack
      direction='row'
      sx={mergeSx(
        {
          alignItems: 'center',
          gap: 1,
        },
        styles.root
      )}
    >
      <InfoIcon sx={styles.icon} />
      <Typography variant='body3' sx={styles.message}>
        {message}
      </Typography>
    </Stack>
  );
};

export default BetslipErrorMessage;
